import React from 'react';
import { Typography } from '@material-ui/core';
import CustomToolbar from '../../common/CustomToolbar/CustomToolbar';
import globals from '../../../globals/communityGlobals';

const locale = globals.getAreas(['nonPatientActivityTypes', 'error']);

export const tableSettings = options => ({
  name: <Typography variant="h3">NonPatient Activity Type</Typography>,
  columns: [
    {
      name: 'id',
      label: 'Id',
      options: {
        display: 'excluded',
      },
    },
    {
      name: 'name',
      label: locale.getMsg('name'),
    },
  ],
  options: {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    rowsPerPageOptions: [5, 15, 30, 50, 100],
    rowsPerPage: 15,
    print: false,
    search: true,
    download: false,
    filter: false,
    viewColumns: false,
    customToolbar: () => (
      <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
    ),
    onRowClick: rowData => options.eventHandlers.setSelectedModel({ id: rowData[0], name: rowData[1] }),
  },
});
